import { i18n } from "@/boot/i18n";

export const LANGUAGES = [
  { value: "pt_BR", label: i18n.t("consts.language.portuguese") },
  { value: "es_ES", label: i18n.t("consts.language.spain") },
  { value: "en_US", label: i18n.t("consts.language.english") }
];

export const LANGUAGES_LABELS = {
  pt_BR: "consts.language.portuguese",
  en_US: "consts.language.english",
  es_ES: "consts.language.spain"
};

export const LANGUAGES_LABELS_ABBR = {
  pt_BR: "consts.language.abbr.pt_BR",
  en_US: "consts.language.abbr.en_US",
  es_ES: "consts.language.abbr.es_ES"
};

export const OFFSETS = [
  { value: -12, label: "(GMT -12:00) Eniwetok, Kwajalein", timezone: "Pacific/Kwajalein"  },
  { value: -11, label: "(GMT -11:00) Midway Island, Samoa", timezone: "Pacific/Midway" },
  { value: -10, label: "(GMT -10:00) Hawaii", timezone: "Pacific/Honolulu" },
  { value: -9, label: "(GMT -9:00) Alaska", timezone: "US/Alaska" },
  { value: -8, label: "(GMT -8:00) Pacific Time (US & Canada)", timezone: "America/Los_Angeles" },
  { value: -7, label: "(GMT -7:00) Mountain Time (US & Canada)", timezone: "America/Denver" },
  { value: -6, label: "(GMT -6:00) Central Time (US & Canada), Mexico City", timezone: "America/Mexico_City" },
  { value: -5, label: "(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima", timezone: "America/Bogota" },
  { value: -4, label: "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz", timezone: "America/Caracas" },
  { value: -3.5, label: "(GMT -3:30) Newfoundland", timezone: "America/St_Johns" },
  { value: -3, label: "(GMT -3:00) Brazil, Buenos Aires, Georgetown", timezone: "America/Sao_Paulo" },
  { value: -2, label: "(GMT -2:00) Mid-Atlantic", timezone: "America/Noronha" },
  { value: -1, label: "(GMT -1:00) Azores, Cape Verde Islands", timezone: "Atlantic/Cape_Verde" },
  { value: 0, label: "(GMT) Western Europe Time, London, Lisbon, Casablanca", timezone: "Europe/London" },
  { value: 1, label: "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris", timezone: "Europe/Paris" },
  { value: 2, label: "(GMT +2:00) Kaliningrad, South Africa", timezone: "Europe/Moscow" },
  { value: 3, label: "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg", timezone: "Asia/Baghdad" },
  { value: 3.5, label: "(GMT +3:30) Tehran", timezone: "Asia/Tehran" },
  { value: 4, label: "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi", timezone: "Asia/Dubai" },
  { value: 4.5, label: "(GMT +4:30) Kabul", timezone: "Asia/Kabul" },
  { value: 5, label: "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent", timezone: "Asia/Karachi" },
  { value: 5.5, label: "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi", timezone: "Asia/Calcutta" },
  { value: 5.75, label: "(GMT +5:45) Kathmandu", timezone: "Asia/Katmandu" },
  { value: 6, label: "(GMT +6:00) Almaty, Dhaka, Colombo", timezone: "Asia/Almaty" },
  { value: 7, label: "(GMT +7:00) Bangkok, Hanoi, Jakarta", timezone: "Asia/Bangkok" },
  { value: 8, label: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong", timezone: "Asia/Hong_Kong" },
  { value: 9, label: "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk", timezone: "Asia/Tokyo" },
  { value: 9.5, label: "(GMT +9:30) Adelaide, Darwin", timezone: "Australia/Adelaide" },
  { value: 10, label: "(GMT +10:00) Eastern Australia, Guam, Vladivostok", timezone: "Australia/Sydney" },
  { value: 11, label: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia", timezone: "Asia/Magadan" },
  { value: 12, label: "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka", timezone: "Pacific/Auckland" }
];

export const COUNTRY_CODE_PHONE_OPTION = [
  { value: 93, label: "+93 - " + i18n.t("consts.country.afghanistan") },
  { value: 358, label: "+358 - " + i18n.t("consts.country.aland_islands") },
  { value: 355, label: "+355 - " + i18n.t("consts.country.albania") },
  { value: 213, label: "+213 - " + i18n.t("consts.country.algeria") },
  { value: 1684, label: "+1684 - " + i18n.t("consts.country.americansamoa") },
  { value: 376, label: "+376 - " + i18n.t("consts.country.andorra") },
  { value: 244, label: "+244 - " + i18n.t("consts.country.angola") },
  { value: 1264, label: "+1264 - " + i18n.t("consts.country.anguilla") },
  { value: 6721, label: "+672-1 - " + i18n.t("consts.country.antarctica") },
  { value: 1268, label: "+1268 - " + i18n.t("consts.country.antigua_and_barbuda") },
  { value: 54, label: "+54 - " + i18n.t("consts.country.argentina") },
  { value: 374, label: "+374 - " + i18n.t("consts.country.armenia") },
  { value: 297, label: "+297 - " + i18n.t("consts.country.aruba") },
  { value: 61, label: "+61 - " + i18n.t("consts.country.australia") },
  { value: 43, label: "+43 - " + i18n.t("consts.country.austria") },
  { value: 994, label: "+994 - " + i18n.t("consts.country.azerbaijan") },
  { value: 1242, label: "+1242 - " + i18n.t("consts.country.bahamas") },
  { value: 973, label: "+973 - " + i18n.t("consts.country.bahrain") },
  { value: 880, label: "+880 - " + i18n.t("consts.country.bangladesh") },
  { value: 1246, label: "+1246 - " + i18n.t("consts.country.barbados") },
  { value: 375, label: "+375 - " + i18n.t("consts.country.belarus") },
  { value: 32, label: "+32 - " + i18n.t("consts.country.belgium") },
  { value: 501, label: "+501 - " + i18n.t("consts.country.belize") },
  { value: 229, label: "+229 - " + i18n.t("consts.country.benin") },
  { value: 1441, label: "+1441 - " + i18n.t("consts.country.bermuda") },
  { value: 975, label: "+975 - " + i18n.t("consts.country.bhutan") },
  { value: 591, label: "+591 - " + i18n.t("consts.country.bolivia_plurinational_state_of") },
  { value: 387, label: "+387 - " + i18n.t("consts.country.bosnia_and_herzegovina") },
  { value: 267, label: "+267 - " + i18n.t("consts.country.botswana") },
  { value: 55, label: "+55 - " + i18n.t("consts.country.brazil") },
  { value: 246, label: "+246 - " + i18n.t("consts.country.british_indian_ocean_territory") },
  { value: 673, label: "+673 - " + i18n.t("consts.country.brunei_darussalam") },
  { value: 359, label: "+359 - " + i18n.t("consts.country.bulgaria") },
  { value: 226, label: "+226 - " + i18n.t("consts.country.burkina_faso") },
  { value: 257, label: "+257 - " + i18n.t("consts.country.burundi") },
  { value: 855, label: "+855 - " + i18n.t("consts.country.cambodia") },
  { value: 237, label: "+237 - " + i18n.t("consts.country.cameroon") },
  { value: 1, label: "+1 - " + i18n.t("consts.country.canada") },
  { value: 238, label: "+238 - " + i18n.t("consts.country.cape_verde") },
  { value: 345, label: "+ 345 - " + i18n.t("consts.country.cayman_islands") },
  { value: 236, label: "+236 - " + i18n.t("consts.country.central_african_republic") },
  { value: 235, label: "+235 - " + i18n.t("consts.country.chad") },
  { value: 56, label: "+56 - " + i18n.t("consts.country.chile") },
  { value: 86, label: "+86 - " + i18n.t("consts.country.china") },
  { value: 61, label: "+61 - " + i18n.t("consts.country.christmas_island") },
  { value: 61, label: "+61 - " + i18n.t("consts.country.cocos_keeling_islands") },
  { value: 57, label: "+57 - " + i18n.t("consts.country.colombia") },
  { value: 269, label: "+269 - " + i18n.t("consts.country.comoros") },
  { value: 242, label: "+242 - " + i18n.t("consts.country.congo") },
  { value: 243, label: "+243 - " + i18n.t("consts.country.congo_the_democratic_republic_of_the_congo") },
  { value: 682, label: "+682 - " + i18n.t("consts.country.cook_islands") },
  { value: 506, label: "+506 - " + i18n.t("consts.country.costa_rica") },
  { value: 225, label: "+225 - " + i18n.t("consts.country.cote_divoire") },
  { value: 385, label: "+385 - " + i18n.t("consts.country.croatia") },
  { value: 53, label: "+53 - " + i18n.t("consts.country.cuba") },
  { value: 357, label: "+357 - " + i18n.t("consts.country.cyprus") },
  { value: 420, label: "+420 - " + i18n.t("consts.country.czech_republic") },
  { value: 45, label: "+45 - " + i18n.t("consts.country.denmark") },
  { value: 253, label: "+253 - " + i18n.t("consts.country.djibouti") },
  { value: 1767, label: "+1767 - " + i18n.t("consts.country.dominica") },
  { value: 1849, label: "+1849 - " + i18n.t("consts.country.dominican_republic") },
  { value: 593, label: "+593 - " + i18n.t("consts.country.ecuador") },
  { value: 20, label: "+20 - " + i18n.t("consts.country.egypt") },
  { value: 503, label: "+503 - " + i18n.t("consts.country.el_salvador") },
  { value: 240, label: "+240 - " + i18n.t("consts.country.equatorial_guinea") },
  { value: 291, label: "+291 - " + i18n.t("consts.country.eritrea") },
  { value: 372, label: "+372 - " + i18n.t("consts.country.estonia") },
  { value: 251, label: "+251 - " + i18n.t("consts.country.ethiopia") },
  { value: 500, label: "+500 - " + i18n.t("consts.country.falkland_islands_malvinas") },
  { value: 298, label: "+298 - " + i18n.t("consts.country.faroe_islands") },
  { value: 679, label: "+679 - " + i18n.t("consts.country.fiji") },
  { value: 358, label: "+358 - " + i18n.t("consts.country.finland") },
  { value: 33, label: "+33 - " + i18n.t("consts.country.france") },
  { value: 594, label: "+594 - " + i18n.t("consts.country.french_guiana") },
  { value: 689, label: "+689 - " + i18n.t("consts.country.french_polynesia") },
  { value: 241, label: "+241 - " + i18n.t("consts.country.gabon") },
  { value: 220, label: "+220 - " + i18n.t("consts.country.gambia") },
  { value: 995, label: "+995 - " + i18n.t("consts.country.georgia") },
  { value: 49, label: "+49 - " + i18n.t("consts.country.germany") },
  { value: 233, label: "+233 - " + i18n.t("consts.country.ghana") },
  { value: 350, label: "+350 - " + i18n.t("consts.country.gibraltar") },
  { value: 30, label: "+30 - " + i18n.t("consts.country.greece") },
  { value: 299, label: "+299 - " + i18n.t("consts.country.greenland") },
  { value: 1473, label: "+1473 - " + i18n.t("consts.country.grenada") },
  { value: 590, label: "+590 - " + i18n.t("consts.country.guadeloupe") },
  { value: 1671, label: "+1671 - " + i18n.t("consts.country.guam") },
  { value: 502, label: "+502 - " + i18n.t("consts.country.guatemala") },
  { value: 44, label: "+44 - " + i18n.t("consts.country.guernsey") },
  { value: 224, label: "+224 - " + i18n.t("consts.country.guinea") },
  { value: 245, label: "+245 - " + i18n.t("consts.country.guinea-bissau") },
  { value: 595, label: "+595 - " + i18n.t("consts.country.guyana") },
  { value: 509, label: "+509 - " + i18n.t("consts.country.haiti") },
  { value: 379, label: "+379 - " + i18n.t("consts.country.holy_see_vatican_city_state") },
  { value: 504, label: "+504 - " + i18n.t("consts.country.honduras") },
  { value: 852, label: "+852 - " + i18n.t("consts.country.hong_kong") },
  { value: 36, label: "+36 - " + i18n.t("consts.country.hungary") },
  { value: 354, label: "+354 - " + i18n.t("consts.country.iceland") },
  { value: 91, label: "+91 - " + i18n.t("consts.country.india") },
  { value: 62, label: "+62 - " + i18n.t("consts.country.indonesia") },
  { value: 98, label: "+98 - " + i18n.t("consts.country.iran_islamic_republic_of_persian_gulf") },
  { value: 964, label: "+964 - " + i18n.t("consts.country.iraq") },
  { value: 353, label: "+353 - " + i18n.t("consts.country.ireland") },
  { value: 44, label: "+44 - " + i18n.t("consts.country.isle_of_man") },
  { value: 972, label: "+972 - " + i18n.t("consts.country.israel") },
  { value: 39, label: "+39 - " + i18n.t("consts.country.italy") },
  { value: 1876, label: "+1876 - " + i18n.t("consts.country.jamaica") },
  { value: 81, label: "+81 - " + i18n.t("consts.country.japan") },
  { value: 44, label: "+44 - " + i18n.t("consts.country.jersey") },
  { value: 962, label: "+962 - " + i18n.t("consts.country.jordan") },
  { value: 77, label: "+77 - " + i18n.t("consts.country.kazakhstan") },
  { value: 254, label: "+254 - " + i18n.t("consts.country.kenya") },
  { value: 686, label: "+686 - " + i18n.t("consts.country.kiribati") },
  { value: 850, label: "+850 - " + i18n.t("consts.country.korea_democratic_peoples_republic_of_korea") },
  { value: 82, label: "+82 - " + i18n.t("consts.country.korea_republic_of_south_korea") },
  { value: 965, label: "+965 - " + i18n.t("consts.country.kuwait") },
  { value: 996, label: "+996 - " + i18n.t("consts.country.kyrgyzstan") },
  { value: 856, label: "+856 - " + i18n.t("consts.country.laos") },
  { value: 371, label: "+371 - " + i18n.t("consts.country.latvia") },
  { value: 961, label: "+961 - " + i18n.t("consts.country.lebanon") },
  { value: 266, label: "+266 - " + i18n.t("consts.country.lesotho") },
  { value: 231, label: "+231 - " + i18n.t("consts.country.liberia") },
  { value: 218, label: "+218 - " + i18n.t("consts.country.libyan_arab_jamahiriya") },
  { value: 423, label: "+423 - " + i18n.t("consts.country.liechtenstein") },
  { value: 370, label: "+370 - " + i18n.t("consts.country.lithuania") },
  { value: 352, label: "+352 - " + i18n.t("consts.country.luxembourg") },
  { value: 853, label: "+853 - " + i18n.t("consts.country.macao") },
  { value: 389, label: "+389 - " + i18n.t("consts.country.macedonia") },
  { value: 261, label: "+261 - " + i18n.t("consts.country.madagascar") },
  { value: 265, label: "+265 - " + i18n.t("consts.country.malawi") },
  { value: 60, label: "+60 - " + i18n.t("consts.country.malaysia") },
  { value: 960, label: "+960 - " + i18n.t("consts.country.maldives") },
  { value: 223, label: "+223 - " + i18n.t("consts.country.mali") },
  { value: 356, label: "+356 - " + i18n.t("consts.country.malta") },
  { value: 692, label: "+692 - " + i18n.t("consts.country.marshall_islands") },
  { value: 596, label: "+596 - " + i18n.t("consts.country.martinique") },
  { value: 222, label: "+222 - " + i18n.t("consts.country.mauritania") },
  { value: 230, label: "+230 - " + i18n.t("consts.country.mauritius") },
  { value: 262, label: "+262 - " + i18n.t("consts.country.mayotte") },
  { value: 52, label: "+52 - " + i18n.t("consts.country.mexico") },
  { value: 691, label: "+691 - " + i18n.t("consts.country.micronesia_federated_states_of_micronesia") },
  { value: 373, label: "+373 - " + i18n.t("consts.country.moldova") },
  { value: 377, label: "+377 - " + i18n.t("consts.country.monaco") },
  { value: 976, label: "+976 - " + i18n.t("consts.country.mongolia") },
  { value: 382, label: "+382 - " + i18n.t("consts.country.montenegro") },
  { value: 1664, label: "+1664 - " + i18n.t("consts.country.montserrat") },
  { value: 212, label: "+212 - " + i18n.t("consts.country.morocco") },
  { value: 258, label: "+258 - " + i18n.t("consts.country.mozambique") },
  { value: 95, label: "+95 - " + i18n.t("consts.country.myanmar") },
  { value: 264, label: "+264 - " + i18n.t("consts.country.namibia") },
  { value: 674, label: "+674 - " + i18n.t("consts.country.nauru") },
  { value: 977, label: "+977 - " + i18n.t("consts.country.nepal") },
  { value: 31, label: "+31 - " + i18n.t("consts.country.netherlands") },
  { value: 599, label: "+599 - " + i18n.t("consts.country.netherlands_antilles") },
  { value: 687, label: "+687 - " + i18n.t("consts.country.new_caledonia") },
  { value: 64, label: "+64 - " + i18n.t("consts.country.new_zealand") },
  { value: 505, label: "+505 - " + i18n.t("consts.country.nicaragua") },
  { value: 227, label: "+227 - " + i18n.t("consts.country.niger") },
  { value: 234, label: "+234 - " + i18n.t("consts.country.nigeria") },
  { value: 683, label: "+683 - " + i18n.t("consts.country.niue") },
  { value: 6723, label: "+672-3 - " + i18n.t("consts.country.norfolk_island") },
  { value: 1670, label: "+1670 - " + i18n.t("consts.country.northern_mariana_islands") },
  { value: 47, label: "+47 - " + i18n.t("consts.country.norway") },
  { value: 968, label: "+968 - " + i18n.t("consts.country.oman") },
  { value: 92, label: "+92 - " + i18n.t("consts.country.pakistan") },
  { value: 680, label: "+680 - " + i18n.t("consts.country.palau") },
  { value: 970, label: "+970 - " + i18n.t("consts.country.palestinian_territory_occupied") },
  { value: 507, label: "+507 - " + i18n.t("consts.country.panama") },
  { value: 675, label: "+675 - " + i18n.t("consts.country.papua_new_guinea") },
  { value: 595, label: "+595 - " + i18n.t("consts.country.paraguay") },
  { value: 51, label: "+51 - " + i18n.t("consts.country.peru") },
  { value: 63, label: "+63 - " + i18n.t("consts.country.philippines") },
  { value: 872, label: "+872 - " + i18n.t("consts.country.pitcairn") },
  { value: 48, label: "+48 - " + i18n.t("consts.country.poland") },
  { value: 351, label: "+351 - " + i18n.t("consts.country.portugal") },
  { value: 1939, label: "+1939 - " + i18n.t("consts.country.puerto_rico") },
  { value: 974, label: "+974 - " + i18n.t("consts.country.qatar") },
  { value: 40, label: "+40 - " + i18n.t("consts.country.romania") },
  { value: 7, label: "+7 - " + i18n.t("consts.country.russia") },
  { value: 250, label: "+250 - " + i18n.t("consts.country.rwanda") },
  { value: 262, label: "+262 - " + i18n.t("consts.country.reunion") },
  { value: 590, label: "+590 - " + i18n.t("consts.country.saint_barthelemy") },
  { value: 290, label: "+290 - " + i18n.t("consts.country.saint_helena_ascension_and_tristan_da_cunha") },
  { value: 1869, label: "+1869 - " + i18n.t("consts.country.saint_kitts_and_nevis") },
  { value: 1758, label: "+1758 - " + i18n.t("consts.country.saint_lucia") },
  { value: 590, label: "+590 - " + i18n.t("consts.country.saint_martin") },
  { value: 508, label: "+508 - " + i18n.t("consts.country.saint_pierre_and_miquelon") },
  { value: 1784, label: "+1784 - " + i18n.t("consts.country.saint_vincent_and_the_grenadines") },
  { value: 685, label: "+685 - " + i18n.t("consts.country.samoa") },
  { value: 378, label: "+378 - " + i18n.t("consts.country.san_marino") },
  { value: 239, label: "+239 - " + i18n.t("consts.country.sao_tome_and_principe") },
  { value: 966, label: "+966 - " + i18n.t("consts.country.saudi_arabia") },
  { value: 221, label: "+221 - " + i18n.t("consts.country.senegal") },
  { value: 381, label: "+381 - " + i18n.t("consts.country.serbia") },
  { value: 248, label: "+248 - " + i18n.t("consts.country.seychelles") },
  { value: 232, label: "+232 - " + i18n.t("consts.country.sierra_leone") },
  { value: 65, label: "+65 - " + i18n.t("consts.country.singapore") },
  { value: 421, label: "+421 - " + i18n.t("consts.country.slovakia") },
  { value: 386, label: "+386 - " + i18n.t("consts.country.slovenia") },
  { value: 677, label: "+677 - " + i18n.t("consts.country.solomon_islands") },
  { value: 252, label: "+252 - " + i18n.t("consts.country.somalia") },
  { value: 27, label: "+27 - " + i18n.t("consts.country.south_africa") },
  { value: 211, label: "+211 - " + i18n.t("consts.country.south_sudan") },
  { value: 500, label: "+500 - " + i18n.t("consts.country.south_georgia_and_the_south_sandwich_islands") },
  { value: 34, label: "+34 - " + i18n.t("consts.country.spain") },
  { value: 94, label: "+94 - " + i18n.t("consts.country.sri_lanka") },
  { value: 249, label: "+249 - " + i18n.t("consts.country.sudan") },
  { value: 597, label: "+597 - " + i18n.t("consts.country.suriname") },
  { value: 47, label: "+47 - " + i18n.t("consts.country.svalbard_and_jan_mayen") },
  { value: 268, label: "+268 - " + i18n.t("consts.country.swaziland") },
  { value: 46, label: "+46 - " + i18n.t("consts.country.sweden") },
  { value: 41, label: "+41 - " + i18n.t("consts.country.switzerland") },
  { value: 963, label: "+963 - " + i18n.t("consts.country.syrian_arab_republic") },
  { value: 886, label: "+886 - " + i18n.t("consts.country.taiwan") },
  { value: 992, label: "+992 - " + i18n.t("consts.country.tajikistan") },
  { value: 255, label: "+255 - " + i18n.t("consts.country.tanzania_united_republic_of_tanzania") },
  { value: 66, label: "+66 - " + i18n.t("consts.country.thailand") },
  { value: 670, label: "+670 - " + i18n.t("consts.country.timor-leste") },
  { value: 228, label: "+228 - " + i18n.t("consts.country.togo") },
  { value: 690, label: "+690 - " + i18n.t("consts.country.tokelau") },
  { value: 676, label: "+676 - " + i18n.t("consts.country.tonga") },
  { value: 1868, label: "+1868 - " + i18n.t("consts.country.trinidad_and_tobago") },
  { value: 216, label: "+216 - " + i18n.t("consts.country.tunisia") },
  { value: 90, label: "+90 - " + i18n.t("consts.country.turkey") },
  { value: 993, label: "+993 - " + i18n.t("consts.country.turkmenistan") },
  { value: 1649, label: "+1649 - " + i18n.t("consts.country.turks_and_caicos_islands") },
  { value: 688, label: "+688 - " + i18n.t("consts.country.tuvalu") },
  { value: 256, label: "+256 - " + i18n.t("consts.country.uganda") },
  { value: 380, label: "+380 - " + i18n.t("consts.country.ukraine") },
  { value: 971, label: "+971 - " + i18n.t("consts.country.united_arab_emirates") },
  { value: 44, label: "+44 - " + i18n.t("consts.country.united_kingdom") },
  { value: 1, label: "+1 - " + i18n.t("consts.country.united_states") },
  { value: 598, label: "+598 - " + i18n.t("consts.country.uruguay") },
  { value: 998, label: "+998 - " + i18n.t("consts.country.uzbekistan") },
  { value: 678, label: "+678 - " + i18n.t("consts.country.vanuatu") },
  { value: 58, label: "+58 - " + i18n.t("consts.country.venezuela_bolivarian_republic_of_venezuela") },
  { value: 84, label: "+84 - " + i18n.t("consts.country.vietnam") },
  { value: 1284, label: "+1284 - " + i18n.t("consts.country.virgin_islands_british") },
  { value: 1340, label: "+1340 - " + i18n.t("consts.country.virgin_islands_us") },
  { value: 681, label: "+681 - " + i18n.t("consts.country.wallis_and_futuna") },
  { value: 967, label: "+967 - " + i18n.t("consts.country.yemen") },
  { value: 260, label: "+260 - " + i18n.t("consts.country.zambia") },
  { value: 263, label: "+263 - " + i18n.t("consts.country.zimbabwe") }
];
